import { useMutation } from '@tanstack/react-query';

import { declineRfq } from '../../common/api/clients/rfq.api';
import { queries } from '../../common/api/queryKeys/queries';
import { queryClient } from '../../lib/queryClient';

export const useRfqDecline = () => {
    return useMutation({
        mutationFn: declineRfq,
        onSuccess: async (data) => {
            await queryClient.invalidateQueries({ queryKey: queries.requestsForQuotes.detail(data.id).queryKey });
        },
    });
};
